<template lang="html">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div
            @click="$emit('cancel')"
            class="close-modal-wrapper"
          >
            <i class="icon icon--cross"></i>
          </div>

          <div class="modal-body">
            <slot></slot>
          </div>

          <div
            class="modal-footer"
            v-if="isShowFooterButtons"
          >
            <div class="form__buttons buttonset">
              <button
                class="buttonset__button btn btn--secondary active"
                @click="$emit('cancel', $event)"
              >{{ $t('common.cancel') }}</button>
              <button
                class="buttonset__button btn btn--main"
                @click="$emit('confirmed', $event)"
              >{{ $t('common.confirm') }}</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ListModal',
  props: {
    isShowFooterButtons: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      windowHeight: window.outerHeight,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/_mixins.scss';
@import '~styles/app.scss';

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    background-color: rgba(0, 0, 0, .7);
    transition: opacity .3s ease;
    min-width: 320px;
  }

  .modal-wrapper {
    width: 50%;
    max-width: 600px;
    bottom: 50%;
    right: 50%;
    position: fixed;
    transform: translate(50%, 50%);
    display: table-cell;
    vertical-align: middle;

    @media screen and (max-width: 760px) {
      width: 100%;
      max-width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      transform: translate(0);
      overflow-x: auto;
    }
  }

  .modal-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0px auto;
    padding: 40px 80px;
    background-color: var(--white);
    border-radius: 2px;
    @include shadow(3);
    transition: all .3s ease;
    position: relative;

    @media screen and (max-width: 760px) {
      width: 100vw;
      min-width: calc(320px - 20px);
      height: 100vh;
      padding: 40px 30px;
    }

    .close-modal-wrapper {
      position: absolute;
      top: 10px;
      right: 0;
      font-size: 31px;
      display: inline-block;
      padding: 2px 11px;
      cursor: pointer;
      color: var(--brand-orange);
      transition: all 225ms ease-in-out;

      @media screen and (max-width: 550px) {
        position: absolute;
        top: 0;
        left: auto;
        right: 0;
      }

      &:hover {
        color: var(--brand-blue);
        transition: all 225ms ease-in-out;
      }
    }

    .modal-footer {
      justify-content: center;
      display: flex;
      margin-top: 30px;

      .buttonset {
        @media screen and (max-width: 760px) {
          justify-content: space-between;
          width: 100%;

          .btn {
            max-height: 60px;
            font-size: large;
            width: calc(50% - 7.5px);
          }
        }
      }
    }
  }

  .modal-header {
    color: var(--brand-orange);
    position: relative;
    margin-top: -40px;

    .header {
      margin-top: 0;
    }

  }

  .modal-body {
    // margin: 0 0 30px 0;
    height: auto;
    max-height: 60vh;
    overflow-y: auto;

    @media screen and (max-width: 760px) {
      height: 100%;
      max-height: 100%;
      padding: 0 20px;
      overflow-y: auto;
    }
  }

  .modal-default-button {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/ListModal.vue